import { render, staticRenderFns } from "./PricingAccept.vue?vue&type=template&id=15b517ae&"
import script from "./PricingAccept.vue?vue&type=script&lang=js&"
export * from "./PricingAccept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports